// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__1AdiH","inner":"style_inner__35hfl","bottom":"style_bottom__3vayC","copyright":"style_copyright__1lX81"};